import { render } from "./serviceOverviewItemCardSkeleton.vue?vue&type=template&id=2a212ee4&ts=true"
import script from "./serviceOverviewItemCardSkeleton.vue?vue&type=script&lang=ts"
export * from "./serviceOverviewItemCardSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__